module.exports = __webpack_public_path__ + "static/referencia-ca71a41a8886f5e8868a483134cdd25d.jpg";